import ITown from "../../interfaces/ITown";
import {Location, LocationType} from "../../types/Location";
import TownAPIs from "../../APIs/TownAPIs";
import ArrayUtils from "../../helpers/ArrayUtils";
import IPartner from "../../interfaces/IPartner";

/**
 *
 * @param towns
 * @param locationType
 */
export async function fetchTownsInRadius(towns: ITown[], locationType: LocationType): Promise<ITown[]>{
    if (locationType !== LocationType.City) return [];

    const { insee, lat, lng } = towns[0];

    if ( insee && lat && lng) {
        return TownAPIs.findTownsInRadius({insee: insee, lat: lat, lng: lng, radius: 20});
    }

    return [];
}

/**
 *
 * @param location
 */
export async function fetchTownsFromLocation(location: Location): Promise<ITown[]> {
    switch (location.type) {
        case LocationType.Department:
            return TownAPIs.getTownByDepCode( { code: location.departmentId });
        case LocationType.PostalCode:
            return TownAPIs.getTownsByPostalCode({ postalCode: location.postalCode });
        case LocationType.City:
            return TownAPIs.getTownByParams({
                insee: location.insee,
                townId: location.townId,
                postalCode: location.postalCode
            });
    }
}

/**
 *
 * @param towns
 */
export async function fetchPartners(towns : ITown[]) : Promise<any[]> {
    if (towns.length === 0) return [];

    const townsChunk : ITown[][] = ArrayUtils.chunk(towns, 100);

    const requests : Promise<any[]>[] = townsChunk.map((arr) => {
        const names = arr.map(t => t.normalizedName) as string[];
        const postalCodes = arr.map(t => t.postalCode) as string[];

        return TownAPIs.getInterkabPartnersInMultipleTowns({ names: names, postalCodes: postalCodes });
    });

    const result = await Promise.all(requests);

    return result
        .reduce((acc : any[], value: any[]) => acc.concat(value ?? []), [])
        .sort((a : any, b: any) => Number(a.code) - Number(b.code));
}

/**
 *
 * @param towns
 */
export async function fetchPartnersLocation(towns: ITown[]) : Promise<IPartner[]> {
    if (towns.length === 0) return [];

    const townChunks : ITown[][] = ArrayUtils.chunk(towns, 100);

    const requests : Promise<IPartner[]>[] = townChunks.map((arr) => {
        const names = arr.map(t => t.normalizedName ?? "");
        const postalCodes = arr.map(t => t.postalCode ?? "");
        return TownAPIs.getInterkabPartnersLocationsInMultipleTown({ names: names, postalCodes: postalCodes });
    })

    const result = await Promise.all(requests);

    return result.reduce((acc : IPartner[], value: IPartner[]) => acc.concat(value ?? []), []);
}
